module.exports = __webpack_public_path__ + "static/img/image1.7a6f33bf.png";